export function FormCard({ children, className = "" }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}
